import "./PageTitle.scss";

import clsx from "clsx";
import { Link } from "react-router-dom";

import { BreadcrumbSeparatorIcon } from "../icons";

export interface PageLink {
  title: string;
  path: string;
  isActive: boolean;
  isSeparator?: boolean;
  to?: string;
}

interface PageTitleProps {
  pageTitle: string;
  breadcrumbs?: Array<PageLink>;
  breadcrumbTitle?: string;
}

const PageTitle: React.FC<PageTitleProps> = ({
  pageTitle,
  breadcrumbs,
  breadcrumbTitle,
}) => {
  return (
    <div className="app-toolbar app-content-header-toolbar py-6">
      <div className="app-container d-flex flex-stack container-fluid">
        <div className="page-title d-flex flex-wrap me-3 flex-column justify-content-center">
          <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 mb-2">
            {breadcrumbs && breadcrumbs.length > 0 && (
              <>
                {Array.from(breadcrumbs).map((item, index) => (
                  <li
                    className={clsx("breadcrumb-item", {
                      "text-dark": !item.isSeparator && item.isActive,
                      "text-muted": !item.isSeparator && !item.isActive,
                    })}
                    key={`${item.path}${index}`}
                  >
                    {!item.isSeparator ? (
                      item.to ? (
                        <Link
                          to={item.to}
                          className="text-muted text-decoration-underline :hover:text-decoration-underline"
                        >
                          {item.title}
                        </Link>
                      ) : (
                        <span>{item.title}</span>
                      )
                    ) : (
                      <span className="menu-icon" data-kt-element="icon">
                        <BreadcrumbSeparatorIcon />
                      </span>
                    )}
                  </li>
                ))}
                <li className="breadcrumb-item text-dark">
                  {breadcrumbTitle || pageTitle}
                </li>
              </>
            )}
          </ul>

          <h1 className="page-heading text-dark fw-bold fs-1 my-0 flex-column justify-content-center two-lines-text">
            {pageTitle}
          </h1>
        </div>
      </div>
    </div>
  );
};

export { PageTitle };
